var map = {
	"./Markets.svg": 12545,
	"./Rocket.svg": 1782,
	"./UAE.png": 3715,
	"./UAE.svg": 34209,
	"./USA.svg": 84747,
	"./bitcoin-btc-logo.png": 99926,
	"./change.svg": 54762,
	"./commodities/gas.svg": 66391,
	"./commodities/oil.svg": 26272,
	"./commodities/xag.svg": 74612,
	"./commodities/xau.svg": 30118,
	"./commodities/xcu.svg": 86204,
	"./commodities/xpd.svg": 28564,
	"./commodities/xpt.svg": 4804,
	"./cosmos-atom-logo.png": 44520,
	"./cross.svg": 566,
	"./ethereum-eth-logo.png": 34403,
	"./ethereum-eth-logo.svg": 70957,
	"./pikachu-running.gif": 53696,
	"./pokeball.svg": 45510,
	"./pokemoncard.png": 40197,
	"./price.svg": 67353,
	"./psa10-card.png": 19456,
	"./shop.svg": 36722,
	"./stocks/aapl.svg": 78072,
	"./stocks/amd.svg": 484,
	"./stocks/amzn.svg": 19240,
	"./stocks/avgo.svg": 65437,
	"./stocks/brkb.svg": 75457,
	"./stocks/coin.svg": 85421,
	"./stocks/gme.svg": 39127,
	"./stocks/googl.svg": 50758,
	"./stocks/intel.svg": 32778,
	"./stocks/jpm.svg": 76273,
	"./stocks/meta.svg": 40937,
	"./stocks/msft.svg": 37420,
	"./stocks/nvda.svg": 59675,
	"./stocks/pltr.svg": 99048,
	"./stocks/qbts.svg": 64336,
	"./stocks/qqq.svg": 51525,
	"./stocks/qubt.svg": 19714,
	"./stocks/spy.svg": 53196,
	"./stocks/tsla.svg": 26472,
	"./toasttick.svg": 10124,
	"./topbar/crypto.svg": 2930,
	"./topbar/down.svg": 95553,
	"./topbar/favstar.svg": 66736,
	"./topbar/highlightedstar.svg": 58516,
	"./topbar/realestate.svg": 4197,
	"./topbar/rwa.svg": 72473,
	"./topbar/unhighlightedstar.svg": 22855,
	"./topbar/up.svg": 86718,
	"./trades.svg": 48603,
	"./vaults.svg": 29693,
	"./volume.svg": 42316,
	"./watch/ap.png": 70477,
	"./watch/breitling.png": 94654,
	"./watch/cartier.png": 53938,
	"./watch/omega.png": 14213,
	"./watch/patek.png": 74915,
	"./watch/rolex.png": 68396,
	"./watch/tudor.png": 28984,
	"./watch/watch-index.png": 7154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68810;